import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Kit Anti-Rabietas',
    desc: 'Qué decir y hacer exactamente cuando explota por el celular. Guión de crisis listo.',
    value: '$8.000'
  }, {
    num: '02',
    title: 'Actividades Express 5 Min',
    desc: 'Para esos momentos donde no tenés tiempo ni ganas de armar nada.',
    value: '$10.000'
  }, {
    num: '03',
    title: 'Frases Poderosas',
    desc: '100+ frases para hablar con tu hijo sin gritar, sin amenazar y sin ceder.',
    value: '$9.000'
  }, {
    num: '04',
    title: 'Planificador Primera Semana',
    desc: 'Tu semana 1 resuelta. Sabés qué hacer cada día desde hoy.',
    value: '$8.000'
  }, {
    num: '05',
    title: 'Guía de Salidas Sin Pantallas',
    desc: 'Cómo disfrutar el parque, el restaurant y las visitas sin el "chupete digital".',
    value: '$9.000'
  }, {
    num: '06',
    title: 'Tablero de Logros',
    desc: 'Sistema de motivación para que ELLOS quieran participar y dejen el celu solos.',
    value: '$9.000'
  }];
  return <section className="bg-dark-800 py-20 px-4 border-t border-primary/20" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-4" data-id="element-20">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gold font-bold tracking-widest uppercase" data-id="element-21">
            Siempre Incluidos
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-22">
          {bonuses.map((bono, i) => <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} key={i} className="bg-dark-900 rounded-2xl p-6 flex flex-col md:flex-row items-center border border-primary/20 hover:border-primary/50 transition-colors" data-id="element-23">
              <div className="flex-shrink-0 w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center text-2xl font-bold text-primary mb-4 md:mb-0 md:mr-6" data-id="element-24">
                {bono.num}
              </div>
              <div className="flex-grow text-center md:text-left mb-4 md:mb-0" data-id="element-25">
                <h4 className="text-xl font-bold text-cream mb-2 flex items-center justify-center md:justify-start" data-id="element-26">
                  <span className="mr-2" data-id="element-27">🎁</span> {bono.title}
                </h4>
                <p className="text-cream/70" data-id="element-28">{bono.desc}</p>
              </div>
              <div className="flex-shrink-0 text-center md:text-right" data-id="element-29">
                <p className="line-through text-sm mb-1 text-[#F59F0B]" data-id="element-30">
                  Valor: {bono.value}
                </p>
                <p className="text-cta font-bold text-xl" data-id="element-31">GRATIS</p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary/10 border border-primary/30 rounded-2xl p-8 text-center" data-id="element-32">
          <p className="text-2xl md:text-3xl font-bold text-cream" data-id="element-33">
            Valor total bonos:{' '}
            <span className="text-urgency line-through mx-2" data-id="element-34">$53.000</span>
            <span className="text-cta" data-id="element-35">→ GRATIS</span> con tu MegaPack
          </p>
        </div>
      </div>
    </section>;
}